import React from 'react'
import useAxios from '../utils/useAxios'

function AddCompany() {

    let api = useAxios()

    let postCompany = async (e) => {
        // e.preventDefault()
        let response = await api.post('/api/add-company/', {
            'name': e.target.name.value,
            'image': e.target.image.files[0],
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })

        if (response.status === 200) {
            alert("Company Created Successfully")
        } else {
            alert("There was some errors please try again")
        }


    }

  return (
    <div>
        <div className="modal fade" id="companyModal" tabIndex="-1" aria-labelledby="companyModal" aria-hidden="true">
        <div className="modal-dialog">
            <div className="modal-content">
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">New Invoice</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <form onSubmit={postCompany}>
                <div className="mb-3">
                    <label htmlFor='name' className="col-form-label">Invoice name</label>
                    <input type="text" className="form-control" id="name" name='name' required/>
                </div>


                <div className="mb-3">
                    <label htmlFor='image' className="form-label">Default file input example</label>
                    <input className="form-control" type="file" accept="image/png, image/jpeg" id="image" name='image' />
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <input type="submit" className="btn btn-success" value="Add" data-bs-dismiss="modal" />
                </div>
                </form>
            </div>

            </div>
        </div>
        </div>
    </div>
  )
}

export default AddCompany